import React from 'react'

export const IconChevronRight = (props) => {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6.45492 16.4645C6.20653 16.221 6.18395 15.8399 6.38718 15.5714L6.45492 15.4945L12.0612 9.9987L6.45492 4.50289C6.20653 4.25939 6.18395 3.87835 6.38718 3.60984L6.45492 3.53292C6.7033 3.28942 7.09198 3.26728 7.36587 3.46651L7.44434 3.53292L13.5451 9.51371C13.7935 9.75721 13.816 10.1382 13.6128 10.4068L13.5451 10.4837L7.44434 16.4645C7.17112 16.7323 6.72814 16.7323 6.45492 16.4645Z" />
    </svg>
  )
}
